import { useEffect } from 'react';
import type { AspectRatioOption } from '../types';
import { useCropStore } from '../store/cropStore';

export const useImageLoader = (imageUrl: string, initialAspectRatio?: number): void => {
  const { setImageLoaded, setOriginalDimensions, setAspectRatio, resetState } = useCropStore();

  useEffect(() => {
    if (imageUrl) {
      setImageLoaded(false);
      const img = new Image();

      img.onload = (): void => {
        setOriginalDimensions(img.width, img.height);
        setImageLoaded(true);

        // Set initial aspect ratio if provided
        if (initialAspectRatio) {
          const aspectRatio: AspectRatioOption = initialAspectRatio === 1 ? '1:1' : 'original';
          setAspectRatio(aspectRatio);
        }
      };

      img.onerror = (): void => {
        console.error('Failed to load image:', imageUrl);
        setImageLoaded(true);
      };

      img.src = imageUrl;
    }

    // Reset state when component unmounts
    return () => resetState();
  }, [
    imageUrl,
    initialAspectRatio,
    setImageLoaded,
    setOriginalDimensions,
    resetState,
    setAspectRatio,
  ]);
};
